import React from "react"
import FieldProto from "../proto/field-proto";

export type FieldViewProps = {
    field           : FieldProto;
    model           : any;
    className?      : string;

    options?        : any
    configOptions?  : any

    onClick?        : func
    viewType?       : string        // specify how to render view for advanced cases i.e. project as full path or name as property

    params?         : any           // some special parameters (like 'availableWidth' for charts)

    children?       : any
}

export default function FieldView(props:FieldViewProps):React.ReactElement {

    // console.log("FIELDVIEW ", props)

    return <props.field.renderComponents.view {...props} />

}